var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.name.length > 1)?_c('i',_vm._b({class:[_vm.set, `fa-${_vm.name}`, { 'fa-fw': _vm.fixed }]},'i',_vm.$attrs,false)):_c('span',_vm._b({staticClass:"font-bold font-normal",class:{ 'fa-fw': _vm.fixed }},'span',_vm.$attrs,false),[_vm._v("\n    "+_vm._s(_vm.name)+"\n  ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }